<!--
  Audit UI/UX (feedback utente su screenshot): la vecchia struttura (stats-row e
  tabella "sciolte" direttamente sullo sfondo grigio della pagina, bottoni
  fluttuanti) non era coerente con lo stile reale dell'app. Ricostruita seguendo
  ESATTAMENTE la struttura di survey-team.component.html (tab "Team", stesso
  posto della pagina survey): un dashboard-card con card-header (icona+titolo+
  descrizione+stats-row) e card-body (toolbar azioni su banda grigia), poi la
  tabella in una card separata sotto - stessi nomi di classe (dashboard-card,
  card-header-top, card-details-buttons, stats-row/stat-item), stesso mix
  Bootstrap (container-fluid, row, d-flex, p-4, border-bottom...) + Angular
  Material gia' in uso li'.
-->
<div class="clinical-onboarding-dashboard container-fluid mb-5">
  @if (loading) {
    <div class="row">
      <mat-progress-bar mode="indeterminate" class="custom-loader"></mat-progress-bar>
    </div>
  }

  <div class="dashboard-card shadow-sm my-4 border-primary">
    <div class="card-header bg-white border-bottom p-4 card-header-top">
      <h4 class="dashboard-card-title text-primary-purple mb-1 d-flex align-items-center">
        <mat-icon class="dashboard-title-icon">badge</mat-icon>
        {{ 'components.clinical-onboarding.dashboard.tab-label' | translate }}
      </h4>
      <p class="text-muted mb-4">{{ 'components.clinical-onboarding.dashboard.description' | translate }}</p>

      @if (kpis) {
        <div class="d-flex stats-row flex-wrap">
          <div class="stat-item mr-5 mb-2">
            <h2 class="mb-0 font-weight-bold text-primary-purple">{{ kpis.clinicians_total }}</h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-clinicians-total' | translate }}</small>
          </div>
          <div class="stat-item mr-5 mb-2">
            <h2 class="mb-0 font-weight-bold text-primary-purple">{{ kpis.documents_received }} <span class="stat-unit">/ {{ kpis.documents_expected }}</span></h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-documents' | translate }}</small>
          </div>
          <div class="stat-item mr-5 mb-2">
            <h2 class="mb-0 font-weight-bold text-success">{{ kpis.documents_verified_ok }}</h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-verified-ok' | translate }}</small>
          </div>
          <div class="stat-item mr-5 mb-2">
            <h2 class="mb-0 font-weight-bold text-success">{{ kpis.paid_count }}</h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-paid' | translate }}</small>
          </div>
          <div class="stat-item mr-5 mb-2">
            <h2 class="mb-0 font-weight-bold text-dark-purple">{{ kpis.amount_paid | number:'1.2-2' }} <span class="stat-unit">EUR</span></h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-amount-paid' | translate }}</small>
          </div>
          <div class="stat-item mb-2">
            <h2 class="mb-0 font-weight-bold text-dark-purple">{{ kpis.amount_remaining_indicative | number:'1.2-2' }} <span class="stat-unit">EUR</span></h2>
            <small class="stat-label">{{ 'components.clinical-onboarding.dashboard.kpi-amount-remaining' | translate }}</small>
          </div>
        </div>
      }
    </div>

    <div class="card-body p-0">
      <div class="row justify-content-center card-details-buttons">
        <div class="col-12 d-flex justify-content-end align-items-center flex-wrap gap-2">
          @if (selection.selected.length > 0) {
            <button mat-stroked-button color="primary" [disabled]="sendingReminder" (click)="sendBulkReminder()">
              <mat-icon class="mr-1">notifications_active</mat-icon>
              {{ 'components.clinical-onboarding.dashboard.send-reminder' | translate:{count: selection.selected.length} }}
            </button>

            <div class="vertical-divider mx-2"></div>
          }
          <button mat-stroked-button class="text-dark-purple border-purple" (click)="openRegisterCandidates()">
            <mat-icon class="mr-1">person_add</mat-icon>
            {{ 'components.clinical-onboarding.dashboard.register-candidates' | translate }}
          </button>
          <button mat-stroked-button class="text-dark-purple border-purple" (click)="openImportCandidates()">
            <mat-icon class="mr-1">group_add</mat-icon>
            {{ 'components.clinical-onboarding.dashboard.import-candidates' | translate }}
          </button>

          <div class="vertical-divider mx-2"></div>

          <mat-form-field appearance="outline" class="status-filter" subscriptSizing="dynamic">
            <mat-select [value]="statusFilter" [placeholder]="'components.clinical-onboarding.dashboard.filter-status' | translate" (selectionChange)="onStatusFilterChange($event.value)">
              <mat-option value="ALL">{{ 'components.clinical-onboarding.dashboard.filter-status-all' | translate }}</mat-option>
              <mat-option [value]="ClinicianMacroStatus.WAITING">{{ 'components.clinical-onboarding.macro-status.waiting' | translate }}</mat-option>
              <mat-option [value]="ClinicianMacroStatus.IN_PROGRESS">{{ 'components.clinical-onboarding.macro-status.in-progress' | translate }}</mat-option>
              <mat-option [value]="ClinicianMacroStatus.SIGNED">{{ 'components.clinical-onboarding.macro-status.signed' | translate }}</mat-option>
              <mat-option [value]="ClinicianMacroStatus.INVOICE_RECEIVED">{{ 'components.clinical-onboarding.macro-status.invoice-received' | translate }}</mat-option>
              <mat-option [value]="ClinicianMacroStatus.PAID">{{ 'components.clinical-onboarding.macro-status.paid' | translate }}</mat-option>
              <mat-option [value]="ClinicianMacroStatus.EXPIRED">{{ 'components.clinical-onboarding.macro-status.expired' | translate }}</mat-option>
              <mat-option [value]="ClinicianMacroStatus.EXCLUDED">{{ 'components.clinical-onboarding.macro-status.excluded' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-stroked-button class="text-dark-purple border-purple" [matMenuTriggerFor]="columnMenu">
            <mat-icon class="mr-1">view_column</mat-icon>
            {{ 'generic.columns' | translate }}
          </button>

          <!--
            Menu di visibilita' colonne: la tabella ha 7 colonne dati oltre a
            identita'/stato/azioni (sempre visibili) - troppe per stare comode a
            schermo tutte insieme. Stesso identico pattern (mat-menu +
            column-picker-header/body + mat-checkbox per riga) gia' in uso in
            survey-team.component.html per lo stesso identico problema.
          -->
          <mat-menu #columnMenu="matMenu" class="column-picker-menu">
            <div class="column-picker-header p-3 border-bottom">
              <h6 class="mb-0 font-weight-bold">{{ 'components.surveys.survey-team.survey-team.customize-columns' | translate }}</h6>
            </div>
            <div class="column-picker-body py-2">
              @for (setting of columnSettings; track setting.key) {
                <div class="px-3 py-1 dropdown-item-container" (click)="$event.stopPropagation()">
                  <mat-checkbox color="primary" [checked]="setting.visible" (change)="toggleColumn(setting)">
                    <span class="small">{{ setting.label | translate }}</span>
                  </mat-checkbox>
                </div>
              }
            </div>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>

  <div class="onboarding-table-container mt-4">
    <div class="dashboard-card onboarding-table-card">
      <mat-table [dataSource]="dataSource" class="w-100 table-primary">
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef class="col-centered col-select">
            <mat-checkbox
              color="primary"
              [checked]="isAllRemindableSelected"
              [disabled]="remindableRows.length === 0"
              [matTooltip]="'components.clinical-onboarding.dashboard.select-all-remindable' | translate"
              (change)="toggleSelectAllRemindable()"
            ></mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered col-select">
            @if (isRemindable(row)) {
              <mat-checkbox color="primary" [checked]="selection.isSelected(row)" (change)="selection.toggle(row)"></mat-checkbox>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef class="left col-name">{{ 'generic.name' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="left col-name">
            <div class="member-info">
              <span class="member-name" [matTooltip]="row.name">{{ row.name || '-' }}</span>
              <span class="member-email text-muted small" [matTooltip]="row.email">{{ row.email }}</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="macro_status">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-macro-status' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            <app-clinical-onboarding-status-badge [macroStatus]="row.macro_status"></app-clinical-onboarding-status-badge>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="verification_ok">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-verification' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            <!-- Bug: mostrava sempre la spunta verde/rossa in base al solo
                 verification_ok, vero anche quando l'IBAN non e' ancora stato
                 inserito - vedi verificationDisplayFor() per lo stato neutro. -->
            <mat-icon
              class="verification-icon"
              [class.verification-ok]="verificationDisplayFor(row).statusClass === 'ok'"
              [class.verification-ko]="verificationDisplayFor(row).statusClass === 'ko'"
              [class.verification-neutral]="verificationDisplayFor(row).statusClass === 'neutral'"
              [matTooltip]="verificationDisplayFor(row).tooltipKey | translate">{{ verificationDisplayFor(row).icon }}</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fiscal_regime">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.wizard.field-fiscal-regime' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (row.fiscal_regime) {
              {{ 'components.clinical-onboarding.fiscal-regime.' + i18nKeySuffix(row.fiscal_regime) | translate }}
            } @else {
              <span class="text-muted small">-</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="net_amount_indicative">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-net-amount' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (row.net_amount_indicative !== null) {
              {{ row.net_amount_indicative | number:'1.2-2' }} <span class="unit">EUR</span>
              @if (row.has_bollo_reminder) {
                <mat-icon class="bollo-reminder-icon" [matTooltip]="'components.clinical-onboarding.dashboard.bollo-reminder' | translate">receipt_long</mat-icon>
              }
            } @else {
              <span class="text-muted small">-</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="documents_received_at">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-documents-received-at' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            {{ (row.documents_received_at | date:'dd/MM/yyyy') || '-' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pa_authorization_status">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-pa-authorization' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            {{ 'components.clinical-onboarding.pa-authorization-status.' + i18nKeySuffix(row.pa_authorization_status) | translate }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="manual_participation_override">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-override' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (row.manual_participation_override) {
              <mat-icon class="override-icon">flash_on</mat-icon>
            } @else {
              <span class="text-muted small">-</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pa_communication_status">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-pa-communication' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (row.pa_communication_status) {
              {{ 'components.clinical-onboarding.pa-communication-status.' + i18nKeySuffix(row.pa_communication_status) | translate }}
            } @else {
              <span class="text-muted small">-</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="col-centered"></mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            @if (isRemindable(row)) {
              <button mat-icon-button color="primary" [disabled]="sendingReminder" [matTooltip]="'components.clinical-onboarding.dashboard.send-reminder-single' | translate" (click)="sendSingleReminder(row)">
                <mat-icon>notifications_active</mat-icon>
              </button>
            }
            <button mat-icon-button color="primary" [matTooltip]="'components.clinical-onboarding.dashboard.view-detail' | translate" (click)="openClinicianDetail(row)">
              <mat-icon>visibility</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      @if (!loading && dataSource.data.length === 0) {
        <div class="empty-state">
          <span class="text-muted">{{ 'components.clinical-onboarding.dashboard.no-clinicians' | translate }}</span>
        </div>
      }
    </div>
  </div>
</div>
